import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';
import { doesUrlExist } from 'gw-portals-url-js';
import styles from './FooterComponent.module.scss';
import metadata from './FooterComponent.metadata.json5';

const FooterComponent = (props) => {
    const tncLink = _.get(appConfig, `tdic.termsOfUseEnternalLink.${process.env.NODE_ENV}`, _.get(appConfig, 'tdic.termsOfUseEnternalLink.development'));
    const { location: { pathname } } = props;
    const {
        tdic: {
            footerInformation: {
                copyRight, address, tagLine, externalLink,
            }, ignoreHeaderFooterPath
        }
    } = appConfig;

    const redirectExternalLink = useCallback((linkType) => {
        const siteLink = _.get(externalLink, `${linkType}.${_.toLower(process.env.NODE_ENV)}`, _.get(externalLink, `${linkType}.development`));
        window.open(siteLink, '_blank');
    }, [externalLink]);

    const redirectSocialMediaExternalLink = useCallback((linkType) => {
        window.open(_.get(externalLink, linkType), '_blank');
    }, [externalLink]);

    const openTOU = useCallback(() => {
        if (doesUrlExist(tncLink)) {
            window.open(tncLink, '_blank');
        } else {
            window.history.push('/error');
        }
    }, []);

    const renderTagLine = useMemo(
        () => {
            const tagLines = tagLine.split('.');
            return (
                <div>
                    <div>
                        {`${tagLines[0]}.`}
                    </div>
                    <div>
                        {`${tagLines[1]}.`}
                        <sup>
                            {`${tagLines[2]}`}
                        </sup>
                    </div>
                </div>
            );
        },
        [tagLine]
    );

    const renderCopyright = useMemo(() => {
        return copyRight.replace('{currentYear}', LocalDateUtil.today().year);
    }, [copyRight]);

    const overrideProps = {
        copyRightElement: {
            content: renderCopyright
        },
        addressLine1: {
            content: _.get(address, 'address1')
        },
        addressLine2: {
            content: _.get(address, 'address2')
        },
        city: {
            content: _.get(address, 'city')
        },
        contactInfo: {
            content: _.get(address, 'contactNumber')
        },
        postCode: {
            content: _.get(address, 'zipCode')
        },
        protectingDentists: {
            content: renderTagLine
        },
        facebookLink: {
            onClick: () => redirectSocialMediaExternalLink('facebook')
        },
        twitterLink: {
            onClick: () => redirectSocialMediaExternalLink('twitter')
        },
        linkedInLink: {
            onClick: () => redirectSocialMediaExternalLink('linkedIn')
        },
        homeUrl: {
            href: _.get(externalLink, `tdicLogoLink.${_.toLower(process.env.NODE_ENV)}`, _.get(externalLink, 'tdicLogoLink.development')),
            target: '_blank'
        },
        privacyUrl: {
            href: _.get(externalLink, `privacyPolicy.${_.toLower(process.env.NODE_ENV)}`, _.get(externalLink, 'privacyPolicy.development'))
        },
        termsOfUseLink: {
            onClick: () => openTOU()
        },
        contactUsLink: {
            href: _.get(externalLink, `contactUs.${_.toLower(process.env.NODE_ENV)}`, _.get(externalLink, 'contactUs.development'))
        },
        siteMapLink: {
            href: _.get(appConfig, `tdic.siteMapExternalLink.${_.toLower(process.env.NODE_ENV)}`, _.get(appConfig, 'tdic.siteMapExternalLink.development'))
        },
        logo: {
            onClick: () => redirectExternalLink('tdicLogoLink')
        }
    };
    const resolvers = {
        resolveClassNameMap: styles
    };
    FooterComponent.propTypes = {
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired
    };
    if (_.includes(ignoreHeaderFooterPath, pathname)) {
        return null;
    }
    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
};
export default withRouter(FooterComponent);
